import { createFileRoute } from '@tanstack/react-router';

import GpsIntegrations from '@/modules/settings/pages/GpsIntegrations';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/settings/gps-integrations/',
)({
  head: () => ({
    meta: [{ title: 'Integrações GPS' }],
  }),
  component: GpsIntegrations,
});
